// extracted by mini-css-extract-plugin
export var closed = "_9f-1";
export var resizer = "_9f-0";